import React, { useState, useEffect, useReducer, useContext } from "react";
import { toast } from "react-toastify";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import AddIcon from "@material-ui/icons/Add";
import FlashOnIcon from "@material-ui/icons/FlashOn";

import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import Title from "../../components/Title";

import { listQuickMessages, deleteQuickMessage } from "../../services/quickMessages.api";
import { i18n } from "../../translate/i18n";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import QuickMessageDialog from "../../components/QuickMessageDialog";
import ConfirmationModal from "../../components/ConfirmationModal";
import toastError from "../../errors/toastError";
import { Box } from "@material-ui/core";
import { isArray } from "lodash";
import { SocketContext } from "../../context/Socket/SocketContext";
import { AuthContext } from "../../context/Auth/AuthContext";


const reducer = (state, action) => {
  if (action.type === "LOAD_QUICKMESSAGES") {
    //console.log("aqui");
    //console.log(action);
    //console.log(action.payload);
    const quickmessages = action.payload;
    const newQuickmessages = [];
    //console.log(newQuickmessages);

    if (isArray(quickmessages)) {
      quickmessages.forEach((quickemessage) => {
        const quickemessageIndex = state.findIndex(
          (u) => u.id === quickemessage.id
        );
        if (quickemessageIndex !== -1) {
          state[quickemessageIndex] = quickemessage;
        } else {
          newQuickmessages.push(quickemessage);
        }
      });
    }

    return [...state, ...newQuickmessages];
  }

  if (action.type === "UPDATE_QUICKMESSAGES") {
    const quickemessage = action.payload;
    const quickemessageIndex = state.findIndex((u) => u.id === quickemessage.id);

    if (quickemessageIndex !== -1) {
      state[quickemessageIndex] = quickemessage;
      return [...state];
    } else {
      return [quickemessage, ...state];
    }
  }

  if (action.type === "DELETE_QUICKMESSAGE") {
    const quickemessageId = action.payload;

    const quickemessageIndex = state.findIndex((u) => u.id === quickemessageId);
    if (quickemessageIndex !== -1) {
      state.splice(quickemessageIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const useStyles = makeStyles((theme) => ({
  // ✅ CORREGIDO: MainPaper dinámico según tema
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
    backgroundColor: theme.mode === 'dark' ? '#1f2937' : theme.palette.background.paper,
    borderRadius: '12px',
    boxShadow: theme.mode === 'dark' ? '0 4px 20px rgba(0,0,0,0.3)' : '0 4px 20px rgba(0,0,0,0.08)',
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
  },
  
  // ✅ CORREGIDO: TableHeader dinámico según tema
  tableHeader: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    fontWeight: 'bold',
  },
  
  tableHeaderCell: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: '0.875rem',
    borderBottom: `1px solid ${theme.palette.primary.dark}`,
  },
  
  // ✅ CORREGIDO: TableRow dinámico según tema
  tableRow: {
    backgroundColor: theme.palette.background.paper,
    '&:hover': {
      backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
    },
    '& td': {
      color: theme.palette.text.primary,
      borderBottom: `1px solid ${theme.mode === 'dark' ? '#374151' : '#e0e0e0'}`,
    },
  },
  
  // ✅ ESTILOS PARA BOTONES DE ACCIÓN
  editButton: {
    color: '#1976d2',
    backgroundColor: 'rgba(25, 118, 210, 0.1)',
    borderRadius: '50%',
    padding: '8px',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      backgroundColor: '#1976d2',
      color: 'white',
      transform: 'scale(1.1)',
      boxShadow: '0 4px 12px rgba(25, 118, 210, 0.4)',
    },
    '&:active': {
      transform: 'scale(0.95)',
    },
  },
  
  deleteButton: {
    color: '#d32f2f',
    backgroundColor: 'rgba(211, 47, 47, 0.1)',
    borderRadius: '50%',
    padding: '8px',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      backgroundColor: '#d32f2f',
      color: 'white',
      transform: 'scale(1.1)',
      boxShadow: '0 4px 12px rgba(211, 47, 47, 0.4)',
    },
    '&:active': {
      transform: 'scale(0.95)',
    },
  },
  
  // ✅ ESTILOS PARA ESTADO
  statusActive: {
    color: '#4caf50',
  },
  
  statusInactive: {
    color: '#9e9e9e',
  },
  
  
  // ✅ CORREGIDO: ShortcodeCell dinámico según tema
  shortcodeCell: {
    fontFamily: 'monospace',
    fontWeight: 'bold',
    backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
    color: theme.palette.text.primary,
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(0.5),
    display: 'inline-block',
    minWidth: 60,
    textAlign: 'center',
  },
  
  // ✅ CORREGIDO: FileLink dinámico según tema
  fileLink: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    cursor: 'pointer',
    fontWeight: '500',
    transition: 'all 0.2s ease',
    '&:hover': {
      color: theme.palette.primary.dark || '#1565c0',
      textDecoration: 'underline',
    },
  },
  
  // ✅ CORREGIDO: NoFileText dinámico según tema
  noFileText: {
    color: theme.palette.text.secondary || '#9e9e9e',
    fontStyle: 'italic',
  },
  
  // ✅ CORREGIDO: SearchField dinámico según tema
  searchField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '25px',
      backgroundColor: theme.mode === 'dark' ? '#374151' : 'white',
      color: theme.palette.text.primary,
      boxShadow: theme.mode === 'dark' ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 8px rgba(0,0,0,0.1)',
      '&:hover': {
        boxShadow: theme.mode === 'dark' ? '0 4px 12px rgba(0,0,0,0.4)' : '0 4px 12px rgba(0,0,0,0.15)',
      },
      '&.Mui-focused': {
        boxShadow: `0 4px 12px ${theme.mode === 'dark' ? 'rgba(59, 130, 246, 0.4)' : 'rgba(25, 118, 210, 0.3)'}`,
      },
      "& fieldset": {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: theme.palette.primary.main,
    },
  },
}));

const Quickemessages = () => {
  const classes = useStyles();
  const theme = useTheme();

  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [selectedQuickemessage, setSelectedQuickemessage] = useState(null);
  const [deletingQuickemessage, setDeletingQuickemessage] = useState(null);
  const [quickemessageModalOpen, setQuickMessageDialogOpen] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [searchParam, setSearchParam] = useState("");
  const [quickemessages, dispatch] = useReducer(reducer, []);
  const { user } = useContext(AuthContext);
  const { profile } = user;

  const socketManager = useContext(SocketContext);

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      fetchQuickemessages();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParam, pageNumber]);

  useEffect(() => {
    const companyId = user.companyId;
    const socket = socketManager.getSocket(companyId);

    socket.on(`company-${companyId}-quickMessage`, (data) => {
      if (data.action === "update" || data.action === "create") {
        dispatch({ type: "UPDATE_QUICKMESSAGES", payload: data.quickMessage });
      }
      if (data.action === "delete") {
        dispatch({ type: "DELETE_QUICKMESSAGE", payload: +data.quickMessageId });
      }
    });
    return () => {
      // ✅ SOLO REMOVER LISTENERS, NO DESCONECTAR EL SOCKET COMPARTIDO
      if (socket && typeof socket.off === 'function') {
        socket.off(`company-${companyId}-quickMessage`);
        socket.off("ready");
        socket.off("connect");
        socket.off("disconnect");
      }
    };
  }, [socketManager, user.companyId]);

  const fetchQuickemessages = async () => {
    try {
      const companyId = localStorage.getItem("companyId");
      //const searchParam = ({ companyId, userId: user.id });
      const { data } = await listQuickMessages({ companyId, userId: user.id });
      //console.log(data);
      dispatch({ type: "LOAD_QUICKMESSAGES", payload: data });
      setHasMore(data.hasMore);
      setLoading(false);
    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenQuickMessageDialog = () => {
    setSelectedQuickemessage(null);
    setQuickMessageDialogOpen(true);
  };

  const handleCloseQuickMessageDialog = () => {
    setSelectedQuickemessage(null);
    setQuickMessageDialogOpen(false);
    //window.location.reload();
    fetchQuickemessages();
  };

  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  const handleEditQuickemessage = (quickemessage) => {
    //console.log(quickemessage);
    setSelectedQuickemessage(quickemessage);
    setQuickMessageDialogOpen(true);
  };

  const handleDeleteQuickemessage = async (quickemessageId) => {
    try {
      await deleteQuickMessage(quickemessageId);
      toast.success(i18n.t("quickMessages.toasts.deleted"));
    } catch (err) {
      toastError(err);
    }
    setDeletingQuickemessage(null);
    setSearchParam("");
    setPageNumber(1);
    fetchQuickemessages();
    dispatch({ type: "RESET" });

  };

  const loadMore = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  const handleScroll = (e) => {
    if (!hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };

  // ✅ FUNCIÓN PARA ABRIR ARCHIVOS - CORREGIDA CON EL MODELO DE LISTA DE ARCHIVOS
  const handleFileClick = (quickemessage) => {
    if (quickemessage.mediaPath) {
      // ✅ USAR LA URL COMPLETA DEL MODELO (ya incluye el backend URL)
      const fileUrl = quickemessage.mediaPath;
      
      // ✅ ABRIR EN NUEVA PESTAÑA
      window.open(fileUrl, '_blank');
    }
  };

  return (
    <MainContainer>
      <ConfirmationModal
        title={deletingQuickemessage && `${i18n.t("quickMessages.confirmationModal.deleteTitle")} ${deletingQuickemessage.shortcode}?`}
        open={confirmModalOpen}
        onClose={setConfirmModalOpen}
        onConfirm={() => handleDeleteQuickemessage(deletingQuickemessage.id)}
      >
        {i18n.t("quickMessages.confirmationModal.deleteMessage")}
      </ConfirmationModal>
      
      <QuickMessageDialog
        resetPagination={() => {
          setPageNumber(1);
          fetchQuickemessages();
        }}
        open={quickemessageModalOpen}
        onClose={handleCloseQuickMessageDialog}
        aria-labelledby="form-dialog-title"
        quickemessageId={selectedQuickemessage && selectedQuickemessage.id}
      />
      
      <MainHeader>
        <Title>
          <Box display="flex" alignItems="center">
            <FlashOnIcon style={{ marginRight: 8 }} />
            {i18n.t("quickMessages.title")}
          </Box>
        </Title>
        <MainHeaderButtonsWrapper>
          <TextField
            placeholder={i18n.t("quickMessages.searchFieldPlaceholder")}
            type="search"
            value={searchParam}
            onChange={handleSearch}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ color: theme.palette.text.secondary || "gray" }} />
                </InputAdornment>
              ),
            }}
            className={classes.searchField}
            style={{ marginRight: 16 }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleOpenQuickMessageDialog}
            startIcon={<AddIcon />}
          >
            {i18n.t("quickMessages.buttons.addReply")}
          </Button>
        </MainHeaderButtonsWrapper>
      </MainHeader>
      
      <Paper
        className={classes.mainPaper}
        variant="outlined"
        onScroll={handleScroll}
      >
        <Table size="small">
          <TableHead>
            <TableRow className={classes.tableHeader}>
              <TableCell className={classes.tableHeaderCell} align="center">
                {i18n.t("quickMessages.table.shortcodeHeader")}
              </TableCell>
              <TableCell className={classes.tableHeaderCell} align="center">
                {i18n.t("quickMessages.table.mediaNameHeader")}
              </TableCell>
              <TableCell className={classes.tableHeaderCell} align="center">
                {i18n.t("quickMessages.table.statusHeader")}
              </TableCell>
              <TableCell className={classes.tableHeaderCell} align="center">
                {i18n.t("quickMessages.table.actionsHeader")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {quickemessages.map((quickemessage) => (
              <TableRow key={quickemessage.id} className={classes.tableRow}>
                <TableCell align="center">
                  <span className={classes.shortcodeCell}>
                    {quickemessage.shortcode}
                  </span>
                </TableCell>
                
                <TableCell align="center" className={classes.fileCell}>
                  {quickemessage.mediaName ? (
                    <span
                      className={classes.fileLink}
                      onClick={() => handleFileClick(quickemessage)}
                      title={i18n.t("quickMessages.tooltips.openAttachment")}
                    >
                      {quickemessage.mediaName}
                    </span>
                  ) : (
                    <span className={classes.noFileText}>{i18n.t("quickMessages.noFile")}</span>
                  )}
                </TableCell>
                
                <TableCell align="center">
                  {quickemessage.geral === true ? (
                    <CheckCircleIcon className={classes.statusActive} />
                  ) : (
                    <CheckCircleIcon className={classes.statusInactive} />
                  )}
                </TableCell>
                
                <TableCell align="center">
                  {(profile === "admin" || profile === "supervisor" ||
                    (profile === "user" && !quickemessage.geral)) && (
                    <>
                      <IconButton
                        size="medium"
                        onClick={() => handleEditQuickemessage(quickemessage)}
                        className={classes.editButton}
                        title={i18n.t("quickMessages.tooltips.edit")}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                      
                      <IconButton
                        size="medium"
                        onClick={(e) => {
                          setConfirmModalOpen(true);
                          setDeletingQuickemessage(quickemessage);
                        }}
                        className={classes.deleteButton}
                        title={i18n.t("quickMessages.tooltips.delete")}
                      >
                        <DeleteOutlineIcon fontSize="small" />
                      </IconButton>
                    </>
                  )}
                </TableCell>
              </TableRow>
            ))}
            {loading && <TableRowSkeleton columns={4} />}
          </TableBody>
        </Table>
      </Paper>
    </MainContainer>
  );
};

export default Quickemessages;